module.exports = __webpack_public_path__ + "assets/images/75a92e88e417263ed49424ec3cf662d3.png";